import React from "react";

import * as Misc from './../misc';

export default class HelpBalloonView extends React.Component {

  componentDidMount() {
    const lightbox = $('.help-balloon-wrapper');
    lightbox.length && lightbox.hide().slideDown(600);
  }

  render() {
    return (
      <div className="exclude-children-from-overflow" onClick={e => Misc.ignore(e, () => this.props.click())}>
        <div className="help-balloon-wrapper" style={{top: '20px', left: '-180px'}}>
          <div className="help-balloon-panel">
            <div className="help-balloon-close-button"/>
            <h13>{this.props.title}</h13>
            <p dangerouslySetInnerHTML={{__html: this.props.text}}></p>
          </div>
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/helpBalloonView.js